import { fetchAuthSession } from "aws-amplify/auth";
import { getStoredIdToken, isStoredTokenExpired, isStoredTokenIssuedInFuture } from "../authToken";

export async function getBuyAdminAuthHeaders(): Promise<Record<string, string>> {
  // Select the current Admin Cognito user, rather than the first token left in storage.
  let idToken = getStoredIdToken();
  if (idToken && (isStoredTokenExpired(idToken) || isStoredTokenIssuedInFuture(idToken))) {
    const session = await fetchAuthSession({ forceRefresh: true });
    idToken = session.tokens?.idToken?.toString() || getStoredIdToken();
    if (!idToken || isStoredTokenExpired(idToken) || isStoredTokenIssuedInFuture(idToken)) {
      throw new Error("Your admin session has expired. Please sign in again.");
    }
  }
  const headers: Record<string, string> = { "Content-Type": "application/json" };
  if (idToken) headers.Authorization = `Bearer ${idToken}`;
  const role = localStorage.getItem("x-hasura-user-role");
  if (role) headers["x-hasura-role"] = role;
  const user = localStorage.getItem("qa-admin-user");
  if (user) headers["x-admin-user"] = user;
  return headers;
}
